<h1>Inspiration and background</h1>

<p>
  Dashboard Dyslexia represents what I see when I see corporate dashboards.
  <br />
  The general meaning is unclear to me. When I focus on a part of it, it does not
  make any sense. And when I move my eyes to another area, it looks like it has changed.
  In general, everything seems to be moving, making me dizzy. I feel lost, discouraged.
  To protect myself, I consider these dashboards as pieces of art: they required
  a lot of effort, they have no obvious meaning, but can be visually nice.
</p>

<p>
  The roots of this piece of art are numerous. I discovered that many people do not
  understand charts. In fact, charts and dashboards are a very specific way
  to convey information, excluding many persons. Also, the complexity of
  corporate dashboards is endlessly growing, ending up with ridiculously complex
  and senseless dashboards.
</p>
